(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[864],{

/***/ 10948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(91164);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1216);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98352);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59699);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FormCountries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88279);
/* harmony import */ var components_molecules_PageType__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10965);
/* harmony import */ var components_molecules_RefundGuarantee__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19190);
/* harmony import */ var components_organisms_Banner__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47447);
/* harmony import */ var components_organisms_Faqs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(37768);
/* harmony import */ var components_organisms_FinancialSlider__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86987);
/* harmony import */ var components_organisms_HowItWorks__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(78354);
/* harmony import */ var components_organisms_OffshoreCompanyRegistration__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(58720);
/* harmony import */ var components_organisms_PackagesNews__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(30913);
/* harmony import */ var components_organisms_RequiredDocument__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(95183);
/* harmony import */ var components_organisms_StepSlider__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(18691);
/* harmony import */ var components_organisms_WhatMakeUsDifferent__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(58722);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(85893);



var _excluded = ["data", "dataJson"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var NewsSlider = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_3__["default"])(function () {
  return __webpack_require__.e(/* import() */ 5593).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/common/company-formation-country/index.js -> " + "components/organisms/NewsSlider"]
  }
});

var CompanyFormationCountry = function CompanyFormationCountry(_ref) {
  var data = _ref.data,
      dataJson = _ref.dataJson,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_ref, _excluded);

  var country = dataJson.country;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_organisms_Banner__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      minHeightBanner: "banner-min-h-635",
      breadcrumbs: dataJson.breadcrumbs,
      title: "".concat(country, " <br/>Company Formation"),
      titleProps: {
        className: "banner-default-title mb-6 lg:mb-10",
        textColor: "banner-title-default-color"
      },
      dataTrustpilot: {
        dataStatic: dataJson.dataTrustpilot,
        dataDefault: data.dataTrustpilot
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        wrapper: {
          className: "bbc-banner-image-country pb-[98px] lg:pb-0"
        },
        src: "/assets/images/offshore/country/".concat(dataJson.banner_image),
        className: "w-full ",
        width: dataJson.banner_image_width || 560,
        height: dataJson.banner_image_height || 456,
        priority: true,
        alt: dataJson.imageAlt
      }),
      bgColor: "bg-bbc-country",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
        className: "hidden py-6 lg:block"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
      className: "absolute left-1/2 -translate-x-1/2 -translate-y-[74px] text-center lg:-translate-y-1/2",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_molecules_PageType__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        data: dataJson.dataPageType
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("section", {
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_organisms_OffshoreCompanyRegistration__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
        data: dataJson.dataRegistration
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      src: "/assets/images/wave/top-wave.png",
      width: 1920,
      height: 125,
      className: "w-full",
      wrapper: {
        className: "w-full"
      },
      alt: "Wave top"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
      className: "bg-bbc-package",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
        className: "container ",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_organisms_PackagesNews__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
          data: (data === null || data === void 0 ? void 0 : data.dataPackage) || [],
          dataStatic: dataJson.dataPackage,
          title: "".concat(country === "United Kingdom" ? "UK" : country, " Company Formation Packages"),
          subFeeArr: props.subFeeArr
        }), dataJson.openBusinessAccount && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
          className: "row mt-10 justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
            className: "col-12 flex items-center lg:col-6",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
              className: "w-full text-center ",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                src: "/assets/images/offshore/company-formation/group_business-offshore-formation.png",
                width: 346,
                height: 297,
                alt: dataJson.businessAccountImgAlt,
                wrapper: {
                  className: "mb-6 lg:mb-10 flex justify-center"
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
                className: "text-2xl font-semibold leading-9 text-bbc-gray",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
                  className: "text-center lg:text-left",
                  children: ["Open a", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("span", {
                    className: "lg:text-bbc-brand-600",
                    children: "business account"
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
                  className: "ext-center lg:mt-4 lg:text-right",
                  children: ["for your", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("span", {
                    className: "lg:text-bbc-brand-600",
                    children: [" ", "UK company", " "]
                  }), "efficiently"]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                othersClass: "mt-6 lg:mt-10 ",
                onClick: /*#__PURE__*/(0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
                  return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return Tawk_API.toggle();

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })),
                children: "Talk To Us"
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
            className: "col-12 mt-6 lg:col-5 lg:mt-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
              className: "shadow-bbc rounded-xl bg-white py-9 px-8",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
                className: "mb-6 text-center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                  src: "/assets/images/common/wise-circle.png",
                  width: 80,
                  height: 80,
                  alt: "wise",
                  wrapper: {
                    className: "inline-block mr-2"
                  }
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                  src: "/assets/images/common/payoneer-circle.png",
                  width: 80,
                  height: 80,
                  alt: "payoneer",
                  wrapper: {
                    className: "inline-block ml-2"
                  }
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("p", {
                className: "mb-3",
                children: "For a business account, we have partnered with:"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("ul", {
                className: "mb-3 pl-5 text-bbc-brand-500",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("li", {
                  className: "list-disc font-medium underline",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("a", {
                    href: "https://wise.com/partner/bbcincorp",
                    target: "_blank",
                    rel: "nofollow noopener noreferrer",
                    children: "Wise"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("li", {
                  className: "list-disc font-medium underline",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("a", {
                    href: "https://tracking.payoneer.com/SH2qL",
                    target: "_blank",
                    rel: "nofollow noopener noreferrer",
                    children: "Payoneer"
                  })
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("p", {
                children: "With their services, your UK company can easily receive and transfer money internationally."
              }), ["Multi-currency business account", "Support 80+ countries all over the world", "Fast transfer with low fees", "Mobile app and available debit cards"].map(function (item, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
                  className: "mt-2 flex items-start first:mt-0",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("span", {
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_6__/* .FaCheckCircle */ .F, {
                      size: 16,
                      className: "mr-2 mt-1 text-bbc-brand-600"
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("span", {
                    dangerouslySetInnerHTML: {
                      __html: item
                    },
                    className: ""
                  })]
                }, index);
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("p", {
                className: "mt-3",
                children: "Incorporate your UK company with us! We offer free support for your business account."
              })]
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_molecules_RefundGuarantee__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          className: "mb-10 pt-6 lg:mb-20 lg:pt-10"
        }), dataJson.dataFinancial && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(GroupFinancial, {
          data: dataJson.dataFinancial
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_organisms_WhatMakeUsDifferent__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
        title: "Bring your next business venture online",
        data: dataJson.dataWhatMakeUsDifferent,
        className: "bg-wmud py-[60px]"
      }), dataJson.dataOpenBankAccount && typeof dataJson.dataOpenBankAccount === "object" && Object.keys(dataJson.dataOpenBankAccount).length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_organisms_StepSlider__WEBPACK_IMPORTED_MODULE_19__["default"], {
        data: dataJson.dataOpenBankAccount,
        imgAlt: dataJson.dataOpenBankAccount.alt
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_organisms_HowItWorks__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        title: country,
        subTitle: "Company Incorporation Process",
        data: dataJson.dataHowItWorks,
        className: "py-10 lg:py-20"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_organisms_RequiredDocument__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
        title: dataJson.dataRequiredDocument.title || "Required Documents",
        data: dataJson.dataRequiredDocument,
        sectionClassName: "py-10 lg:py-20",
        backgroundImage: "/assets/images/common/required-documents.png"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("section", {
      className: "relative",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
        className: " absolute hidden h-1/2 w-full bg-bbc-package md:block"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
        className: "container relative  z-10 pt-10 lg:pt-20",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_molecules_FormCountries__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            title: dataJson.dataFormContact.title,
            description: dataJson.dataFormContact.description,
            country_id: dataJson.dataFormContact.country_id
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        src: "/assets/images/wave/bottom-wave.png",
        width: 1920,
        height: 140,
        className: "w-full",
        wrapper: {
          className: "absolute w-full top-1/2 hidden md:block"
        },
        alt: "Wave bottom"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
          className: "lg:col-10 lg:m-auto",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_organisms_Faqs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            data: dataJson.dataFaqs,
            title: dataJson.dataFaqs.title,
            description: dataJson.dataFaqs.description,
            defaultActiveKey: dataJson.dataFaqs.defaultActiveKey,
            multipleOpen: dataJson.dataFaqs.multipleOpen
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    })]
  });
};

var GroupFinancial = function GroupFinancial(_ref3) {
  var _data$taxhub, _data$taxhub2, _data$taxhub3;

  var data = _ref3.data;

  var CardFinancial = function CardFinancial(_ref4) {
    var item = _ref4.item;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
      className: "flex h-full flex-col rounded-xl bg-white  shadow-[8px_18px_13px_rgba(152,152,152,0.04)]",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
        className: "flex h-14 justify-center rounded-t-xl",
        style: {
          backgroundColor: item.bgColor
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _objectSpread({
          className: "h-full w-full overflow-hidden rounded object-none object-center transition-all duration-700 group-hover:scale-110 group-hover:transform"
        }, item === null || item === void 0 ? void 0 : item.logo))
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
        className: "flex grow flex-col justify-between p-6",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("p", {
            className: "mb-4 text-[#677294]",
            children: item.description
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("ul", {
            className: "mb-4",
            children: item.options.map(function (option, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("li", {
                className: "flex text-bbc-brand-600",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("span", {
                  className: "mr-3 inline-block",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_6__/* .FaCheckCircle */ .F, {
                    className: "inline text-bbc-brand-600 "
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("span", {
                  className: "font-medium text-[#4255A5]",
                  children: option
                })]
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
          className: "text-center ",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("a", {
            href: item.href,
            rel: "dofollow",
            title: "Explore features",
            className: "text-bbc-brand-500",
            children: item === null || item === void 0 ? void 0 : item.name
          })
        })]
      })]
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
    className: "mb-10 lg:mb-20",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
      className: "row mb-0 items-center justify-end lg:mb-10",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
        className: "col-12 mb-14 flex justify-center lg:col-6 lg:mb-0",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, data === null || data === void 0 ? void 0 : data.logo), {}, {
          loading: "lazy"
        }))
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
        className: "col-12 mb-6 lg:col-5 lg:mb-0",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
          className: "relative rounded-lg bg-white p-10 drop-shadow-sm",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("p", {
            className: "mb-4 text-[#677294]",
            children: data === null || data === void 0 ? void 0 : (_data$taxhub = data.taxhub) === null || _data$taxhub === void 0 ? void 0 : _data$taxhub.description
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("p", {
            className: "text-[#4255A5]",
            children: data === null || data === void 0 ? void 0 : (_data$taxhub2 = data.taxhub) === null || _data$taxhub2 === void 0 ? void 0 : _data$taxhub2.exclusive
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("ul", {
            children: data === null || data === void 0 ? void 0 : (_data$taxhub3 = data.taxhub) === null || _data$taxhub3 === void 0 ? void 0 : _data$taxhub3.options.map(function (option, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("li", {
                className: "flex text-[#4255A5]",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("span", {
                  className: "mr-3 inline-block",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_6__/* .FaCheckCircle */ .F, {
                    className: "inline text-[#4255A5] "
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("span", {
                  className: "font-medium text-[#4255A5]",
                  children: option
                })]
              }, index);
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
            className: "absolute left-1/2 flex h-16 w-16 -translate-x-1/2 items-center justify-center rounded-full bg-white drop-shadow-md",
            style: {
              top: "-2rem"
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _objectSpread({
              alt: "taxHub"
            }, data === null || data === void 0 ? void 0 : data.imageTaxHub))
          })]
        })
      })]
    }), Array.isArray(data.cards) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
      placeholder: data.cards.length > 0 && data.cards.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(CardFinancial, {
          item: item
        }, index);
      }),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(components_organisms_FinancialSlider__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        children: data.cards.length > 0 && data.cards.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
            className: "col-3 !h-auto",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(CardFinancial, {
              item: item
            })
          }, index);
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CompanyFormationCountry);

/***/ }),

/***/ 21337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/common/company-formation-country/index.js
var company_formation_country = __webpack_require__(10948);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/cayman-islands/data.json
var data_namespaceObject = JSON.parse('{"country":"Cayman Islands","banner_image":"banner-cayman-formation.png","breadcrumbs":[{"title":"Company Formation","uri":"/company-formation"},{"title":"Cayman Islands","uri":"/company-formation/cayman-islands"}],"dataTrustpilot":{"content":{"button_placeholder":false,"benefits":["Company formation within 48 hours","Bank account registration support","Dedicated support"],"see_package":"See available package","see_package_id":"PriceTable"}},"dataPageType":[{"title":"Company Formation","uri":"/company-formation/cayman-islands"},{"title":"Open Bank Account","uri":"/company-formation/cayman-islands/open-bank-account"},{"title":"Other Services","uri":"/company-formation/cayman-islands/other-services"}],"dataRegistration":{"country":" Offshore Company Registration in Cayman Islands","data_left":["Well-regulated legislation framework","Thriving banking and financial system","No corporate income tax in Cayman","No exchange control on cross-border transactions","Minimal company maintenance requirements","No public record of company members\' identities","Flexible company structures adapting for multiple business objectives"],"data_right":[{"title":"Cayman Islands Exempted Company","list_regulation":[{"title":"Exempt from corporate taxation","icon":"no-tax.svg"},{"title":"Company formation in 48 hours","icon":"clock.svg"},{"title":"No minimum paid-up capital","icon":"wallet.svg"},{"title":"Customized company registration package","icon":"setting-dollar.svg"},{"title":"All fees included, no hidden charge","icon":"fee.svg"}]}]},"dataPackage":{"listPackage":[{"id":20,"country_id":41,"kind":"basic","price":2699,"className":"","banner":"","checkName":true,"suffix_name":"Exempted Company Limited by Shares","content":[{"subTitle":"Company Formation","listContent":[{"text":"Unlimited Name Availability Check","checkName":true},{"text":"Document Preparation and Filing"},{"text":"Company incorporation process"},{"text":"01 year Company Secretarial service"},{"text":"01 year <span class=\'font-semibold\'>Registered Agent & Local Registered Address</span>"},{"text":"<span class=\'font-semibold\'>All Government fee</span> in 01 year"},{"text":"Digital corporate documents"}]}],"notes":["* This Package includes everything for a foreigner to set up a new Cayman Island Exempted Company Limted by Shares from the beginning"]},{"id":21,"kind":"standard","price":3099,"className":"","banner":"","content":[{"subTitle":"Everything in Basic package"},{"subTitle":"Open Bank Account","listContent":[{"text":"One-time fee for application of one bank"},{"text":"Bank account introduction for any banks in the supported list"},{"text":"Certificate of Incumbency (if required)"}]}],"notes":[]},{"id":22,"kind":"premium","price":3399,"className":"","content":[{"subTitle":"Everything in Standard package"},{"subTitle":"Premium Banking Support","listContent":[{"text":"One-time fee for application of up to 5 banks OR till account opened successfully, whichever comes first"},{"text":"Consulting on your suitable alternative banks if you fail your first application"},{"text":"Ability to open bank account remotely"},{"text":"Fast responsiveness even on weekends"},{"text":"Frequent updates on bank account opening process"}]}],"notes":[]}]},"dataWhatMakeUsDifferent":[{"title":"Streamlined process","description":"Start at your own pace. And reduce waiting time for back-and-forth email communication.","img_src":"/assets/images/common/process-wmud.png"},{"title":"E-signature","description":"Collaborate with your partner more easily. Less paperwork, more efficiency.","img_src":"/assets/images/common/e_signature-wmud.png"},{"title":"Digitized KYC","description":"Standardized form & organizational chart to let you control and declare your information effortlessly.","img_src":"/assets/images/common/kyc-wmud.png"},{"title":"Centralized management portal","description":"24/7 access to company documents on high-security cloud infrastructure. And no worry about key compliance deadlines with auto reminder.","img_src":"/assets/images/common/portal-wmud.png"}],"dataHowItWorks":[{"title":"Create your orders","content":"Enter our online order platform for easy onboarding experience and tailor your orders. We have different packages and additional services that suit your goals. All information filled in is secured over 256-bit encrypted line."},{"title":"Make payment","content":"You can settle payment for services via flexible payment options including debit/credit card of Visa, Master, Amex or Bank Transfer. After you complete payments, we will provide you a checklist of required information for Cayman Islands company registration."},{"title":"Collect and verify KYC documents","content":"Once we\'ve received your payment, our customer service will contact you to process the neccessary paperwork. We\'ll guide you to properly prepare documents for incorporation in Cayman Islands via KYC online form. You can also access our digital Client Portal to proceed with the incorporation steps and keep track of the process anytime, anywhere. "},{"title":"Finish the company registration","content":"The electronic documents are ready after 2 working days of company formation, and it takes 3-7 days for courier the original kit."}],"dataRequiredDocument":{"note":"<a rel=\\"nofollow\\" target=\\"_blank\\" href=\\"/files/certified-true-copy-guide.pdf\\"><span class=\'text-bbc-secondary-300 font-normal\'>* See certified true copy guide</span></a>","button":{"type":"talk-to","text":"Talk To Our Expert"},"content":[{"title":"The list below presents general documents needed for Cayman Islands offshore company formation. Contact us if you need further details!copy of passports of all company members","listContent":[{"text":"Notarized / Certified true copies of valid passports for all directors/shareholders","content":[]},{"text":"Notarized / Certified true copies of residency proofs for all company directors/shareholders (i.e. utility bill or credit card bill)","content":[]}]},{"title":"<em class=\'font-normal\'>We also provide true copy certification service for your personal identity documents as per your need.</em>"}]},"dataFormContact":{"title":"Wish to get a hassle-free Cayman Islands company formation?","description":"Just get in touch with us. We typically response within 2 hrs.","country_id":41},"dataFaqs":[{"name":"What are the advantages of exempted company type?","content":"<p>An exempted company is not subject to any kind of corporate taxation given that the company conducts its business mainly outside of Cayman Islands. In addition, the company can request a tax exemption certificate to ensure its tax-free status for a period of up to 20 years.</p><p>Register of company shareholders is not open to the general public. Moreover, company maintenance procedures are simple and straightforward. The company doesn’t need to file its annual account to the government.</p>"},{"name":"How to name an exempted company in Cayman Islands?","content":"The name of an exempted company should not contain restricted words i.e. “royal”, “imperial”, “empire”, “municipal”, “chartered”, “co-operative”, “insurance”, “bank”, “assurance”, “gaming”, “lottery”... except with the prior consent of the Registrar. The name must also not be identical to the existing companies already registered. An exempt company does not need to include the word “Limited” or “Ltd” after its name."},{"name":"How long will it take to incorporate a company in Cayman Islands?","content":"Hard copies of corporate documents are ready in around 7-10 working days since full inception of all required documents. Express company formation in 48hrs for Cayman Islands company is also available if requested."},{"name":"What are the annual requirements to maintain an exempted company?","content":"An exempted company have to maintain its local registered agent, registered address. Furthermore, the company needs to pay annual government fee and file an annual return to the Registrar declaring that no changes, other than ones already notified to the Registrar, has been made in Memorandum of Association and no business has been carried out within the country."},{"name":"What business fields required to have a license?","content":"Some business activities required licensing by Cayman Islands Money Authority (CIMA) are banking, money services, insurance, trust, company management services, investment fund, dealing with securities…"}]}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/offshore/company-formation/cayman-islands/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "offshore",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(company_formation_country/* default */.Z, {
      data: data,
      dataJson: data_namespaceObject
    })
  });
}

/***/ }),

/***/ 67162:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/company-formation/cayman-islands",
      function () {
        return __webpack_require__(21337);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,4868,4090,9738,7447,9156,975,913,8721,2888,179], function() { return __webpack_exec__(67162); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);